import { render, staticRenderFns } from "./PurchaseReturnList.vue?vue&type=template&id=9edde7ea&scoped=true"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseReturnList.vue?vue&type=style&index=0&id=9edde7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edde7ea",
  null
  
)

export default component.exports